import type { FC } from "react";
import { GoalDetailSolutionItem } from "web_myplann/Goals/Components/GoalDetailSolutionItem";
import { GoalDetailSolutionItemSkeleton } from "web_myplann/Goals/Components/GoalDetailSolutionItemSkeleton";
import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	portfolios: GoalPortfolioResponseDTO[];
	unpinningId: number | null;
	hasFuture: boolean;
	dueYear: number;
	readOnly?: boolean;
	onUnpin: (portfolioId: number) => void;
	onEditAllocation: (portfolio: GoalPortfolioResponseDTO) => void;
};

export const GoalDetailSolutionList: FC<Props> = ({
	portfolios,
	unpinningId,
	hasFuture,
	dueYear,
	readOnly,
	onUnpin,
	onEditAllocation,
}) => (
	<>
		{portfolios.map((portfolio, i) =>
			portfolio.portfolioId === unpinningId ? (
				<GoalDetailSolutionItemSkeleton
					key={portfolio.portfolioId}
					hasDivider={i < portfolios.length - 1}
				/>
			) : (
				<GoalDetailSolutionItem
					key={portfolio.portfolioId}
					portfolio={portfolio}
					hasDivider={i < portfolios.length - 1 || hasFuture}
					dueYear={dueYear}
					readOnly={readOnly}
					onUnpin={onUnpin}
					onEditAllocation={onEditAllocation}
				/>
			),
		)}
	</>
);
